import baseAPI from '../app/axios';
import { getSessionToken } from '../app/utils';

export default class MitakeService {
  static async getData(orgId) {
    if (!orgId) {
      throw new Error('MitakeService.getData: orgId undefined');
    }

    const response = await baseAPI.get(
      `/market/sms/mitake?orgId=${orgId}&_SessionToken=${getSessionToken()}`,
    );

    return response?.config || {};
  }

  static async connect(orgId, config) {
    if (!orgId) {
      throw new Error('MitakeService.connect: orgId undefined');
    }

    if (!config) {
      throw new Error('MitakeService.connect: config undefined');
    }

    const response = await baseAPI.put(`/market/sms/mitake`, {
      orgId,
      config,
    });

    return response;
  }
}
